<footer class="bg-background mt-auto" style="box-shadow: var(--shadow-divider);">
  <div class="mx-auto max-w-360 px-4 sm:px-6 lg:px-12 py-6">
    <div class="flex flex-col sm:flex-row justify-between items-center gap-4">
      <p class="text-small font-medium text-secondary">
        &copy; {{ currentYear() }} Sentinal Books. All rights reserved.
      </p>
      <nav aria-label="Footer links" class="flex gap-6">
        <a href="#" class="text-caption font-medium text-secondary hover:text-primary transition-nike focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus">Privacy</a>
        <a href="#" class="text-caption font-medium text-secondary hover:text-primary transition-nike focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus">Terms</a>
        <a href="#" class="text-caption font-medium text-secondary hover:text-primary transition-nike focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus">Contact</a>
      </nav>
    </div>
  </div>
</footer>
